import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    '& .labelInput': {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.background.paper,
      marginLeft: '15px',
      position: 'absolute',
      top: '-8px',
      zIndex: 100,
      fontSize: '0.75rem',

      '&.error': {
        color: theme.palette.error.main,
      },
    },

    '&:hover': {
      '& .labelInput': {
        color: theme.palette.text.primary,
      },
    },
    '&:focus-within': {
      '& .labelInput': {
        color: theme.palette.primary.main + ' !important',
      },
    },
  },
  error: {
    color: theme.palette.error.main,
    marginTop: theme.spacing(1),
    fontSize: '1rem',
    marginLeft: theme.spacing(2),
  },
  portal: {
    zIndex: 1300,
    position: 'absolute',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
  },
}))

export default useStyles
